import { TextLegal } from '@cbhq/cds-web/typography';

export function FreeCreditsDisclaimerField() {
  return (
    <TextLegal as="p" color="foregroundMuted">
      *Upon the full use of your free credits you will lose access to your API keys if there is no
      alternate payment method on your profile.
    </TextLegal>
  );
}
